































































import { Component, Prop, Vue } from 'vue-property-decorator';
import NumberInput from '@/components/NumberInput.vue';

@Component({
  components: {
    NumberInput,
  },
})
export default class ProductSearchPeopleInput extends Vue {
  @Prop() value!: { adults: number; children: number[] };

  setNumOfAdults(value: number) {
    this.$emit('input', {
      adults: value,
      children: this.value.children,
    });
  }

  setNumOfChildren(value: number) {
    const length = Number(value) || 0;
    const result = [...this.value.children];
    const diff = length - result.length;
    if (diff > 0) {
      result.splice(result.length, Math.abs(diff), ...Array(Math.abs(diff)).fill(0));
    } else {
      result.splice(length, result.length);
    }

    this.$emit('input', {
      adults: this.value.adults,
      children: result,
    });
  }
}
